<template>
  <v-tooltip
    v-if="tooltip"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
      >
        {{ title }}
      </span>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
  <span v-else>{{ title }}</span>
</template>

<script>
export default {
  name: 'TableHeaderWithTooltip',
  props: ['title', 'tooltip'],
};
</script>
